export const GRECIM = 'grecim'